<footer class="footer">
  <div class="footer-content" style="display: flex; justify-content: center; align-items: center;">
    <div class="copyright" style="text-align: center;">
      © 2000-{{currentYear}} Licenced Copyright by TechWyse. All rights reserved.
    </div>
    <!-- <div class="footer-links">
      <a href="/privacy">Privacy Policy</a>
      <a href="/terms">Terms of Service</a>
      <a href="/help">Help Center</a>
    </div> -->
  </div>
</footer>
